module.exports = __webpack_public_path__ + "img/ry2.25a5bd65.svg";